<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">课题组信息</span>
    </div>
    <div class="box">
      <div class="outer_3" v-if="researchGroupDetail">
        <div class="outer_attr" v-for="(info, index) in researchGroupDetail" :key="index">
          <div class="group">
            <span class="attr_name">{{info.name}}</span>
            <span class="attr">{{info.value}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
      </div>
      <div style="height: 10vw;"></div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      researchGroupDictionary: EMKT.researchGroupDictionary,
      researchGroupDetailDisplayOrder: EMKT.researchGroupDetailDisplayOrder,
      researchGroupStatusDictionary: EMKT.researchGroupStatusDictionary,
      researchGroupApproveTypeDictionary: EMKT.researchGroupApproveTypeDictionary
    }
  },
  computed: {
    ...mapGetters([
      'displayChosenResearchGroup', 'isWapp'
    ]),
    researchGroupDetail () {
      if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return undefined
      const info = []
      for (let attr of this.researchGroupDetailDisplayOrder) {
        // 一级单位非医院，不显示科室信息
        if (this.researchGroupDictionary[attr] === 'secondLevelEnterpriseName') {
          if (!this.displayChosenResearchGroup.firstLevelEnterpriseName.includes('医院')) continue
        }
        if (this.researchGroupDictionary[attr]) {
          // 课题组状态转换为文字
          if (this.researchGroupDictionary[attr] === 'status') {
            info.push({name: attr, value: this.researchGroupStatusDictionary[this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]]})
          } else if (this.researchGroupDictionary[attr] === 'approveType') {
            info.push({name: attr, value: this.researchGroupApproveTypeDictionary[this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]]})
          } else if (this.researchGroupDictionary[attr] === 'vipLevel') {
            // info.push({name: attr, value: 'VIP ' + this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]})
          } else {
            info.push({name: attr, value: this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]})
          }
        }
        // 审批原则为限额审批时，需显示审批限额
        if (this.researchGroupDictionary[attr] === 'approveType' && this.displayChosenResearchGroup.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD) {
          info.push({name: '审批限额', value: '¥' + this.splitMoney(this.displayChosenResearchGroup.approveThreshold)})
        }
      }

      return info
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
}
.box {
  /*display: flex;*/
  position: relative;
  /*align-items: center;*/
  /*flex-direction: column;*/
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  margin: 6.67vw auto;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
  flex-shrink: 0;
}
.outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}

.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: bold;
}

.attr {
  opacity: 1;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 3.9vw;
  width: 86.4vw;
}
</style>



// WEBPACK FOOTER //
// ResearchGroupDetail.vue?5a1d6afa